import { useState } from "react";
import { MessageSquare } from "lucide-react";
import { AIChatPanel } from "./AIChatPanel";
import { cn } from "@/lib/utils";

export function FloatingChatBubble() {
  const [chatOpen, setChatOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setChatOpen(true)}
        className={cn(
          "fixed z-50 w-14 h-14 rounded-full",
          "bg-primary text-primary-foreground",
          "flex items-center justify-center",
          "transition-all duration-200 hover:scale-105",
          "bottom-6 right-6 md:bottom-8 md:right-8",
          "mb-16 md:mb-0" // Account for mobile bottom nav
        )}
        aria-label="Open AI Assistant"
      >
        <MessageSquare className="h-6 w-6" />
      </button>

      <AIChatPanel
        open={chatOpen}
        onOpenChange={setChatOpen}
      />
    </>
  );
}
